"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FormattedDate;

var _react = _interopRequireDefault(require("react"));

var _emotion = require("emotion");

var _DarkText = _interopRequireDefault(require("../../DarkText"));

var s = {
  dateWrapper:
  /*#__PURE__*/
  (0, _emotion.css)("line-height:1.71 !important;font-stretch:normal;font-style:normal;")
};
var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];

function FormattedDate(props) {
  var date = props.date,
      fontSize = props.fontSize;
  var year = new Date(date).getFullYear();
  var month = new Date(date).getMonth();
  var day = new Date(date).getDate();
  return _react.default.createElement(_DarkText.default, {
    color: "iron",
    fontSize: fontSize || 14,
    fontSizeS: 10,
    className: s.dateWrapper,
    letterSpacing: "normal"
  }, "".concat(day, " ").concat(monthNames[month], " ").concat(year));
}